export default __webpack_public_path__ + "d8cc60f1dc055e4cd5d25d027718caea.jpeg";